import { useEffect, useState } from 'react'
import { YoutubeRankData } from '../youtubeRankItem'
import LOGO from '../../../assets/images/logoSample.jpeg'
import '../youtubeRank.css'
import { useAppSelector } from '@/redux/hooks'
import { useDialog } from '@/context/dialogContext'
import commonUtils from '@/utils/commonUtils'
import { useResponsive } from '@/hooks/useResponsive'
import { Heart } from 'react-feather'
interface ListItemProps {
  title: string
  noti?: string
  data: YoutubeRankData[]
  setLikeStatus: (
    formData: FormData,
    chnlId: string,
    currentLikeStatus: string,
  ) => void
  isLikedList?: boolean
}

export const YoutubeListItem: React.FC<ListItemProps> = ({
  title,
  noti,
  data,
  setLikeStatus,
  isLikedList,
}) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth)
  const { showAlert } = useDialog()
  const { isMobile, isTablet, isDesktop } = useResponsive()

  const [likesState, setLikesState] = useState(
    data.reduce(
      (acc, item) => {
        acc[item.chnlId] = isAuthenticated ? item.userLikeYn || 'N' : 'N' // 'Y'면 좋아요, 'N'이면 좋아요 없음
        return acc
      },
      {} as Record<string, string>,
    ),
  )

  useEffect(() => {
    setLikesState(
      data.reduce(
        (acc, item) => {
          acc[item.chnlId] = isAuthenticated ? item.userLikeYn || 'N' : 'N'
          return acc
        },
        {} as Record<string, string>,
      ),
    )
  }, [data])

  const formatSubscribers = (num: number): string => {
    if (num >= 10000) {
      return (num / 10000).toFixed(1) + '만' // 반올림
    }
    return num.toLocaleString()
  }

  const formatVideos = (num: number): string => {
    if (num >= 1000) {
      return Math.floor(num / 100) / 10 + '천' // 내림 (예: 1576 → 1.5천)
    }
    return num.toLocaleString()
  }

  const openYouTubeChannel = (chnlId: string) => {
    const url = `https://www.youtube.com/channel/${chnlId}`
    window.open(url, '_blank')
  }

  const handleClick = (chnlId: string) => {
    if (!isAuthenticated) {
      showAlert({
        type: 'error',
        title: '로그인 후 좋아요를 눌러주세요.',
      })
      return
    }
    const newLikesYn = likesState[chnlId] === 'Y' ? 'N' : 'Y'

    setLikesState((prevState) => ({
      ...prevState,
      [chnlId]: newLikesYn,
    }))

    if (user?.cstId) {
      const formData = new FormData()
      formData.append('cstId', user.cstId)
      formData.append('chnlId', chnlId)
      formData.append('likesYn', newLikesYn)
      setLikeStatus(formData, chnlId, likesState[chnlId])
    } else {
      showAlert({
        type: 'error',
        title: '로그인 후 좋아요를 눌러주세요.',
      })
    }
  }

  return (
    <>
      {/* <div className="ranking-header">
        <div className="ranking-title">
          <span>{title}</span>
          {noti && <span style={{ fontSize: '14px' }}>{noti}</span>}
        </div>
      </div> */}
      {/* <div className="ranking-container">
        {data.map((item, index) => (
          <div key={index} className="ranking-item">
            <div className="rank">{item.chnlRank}</div>
            <div
              className="logo"
              onClick={() => openYouTubeChannel(item.chnlId)}
            >
              <img src={item.thumbnailsDefault} alt={LOGO} />
            </div>
            <div
              className="channel-info"
              onClick={() => openYouTubeChannel(item.chnlId)}
            >
              <div className="channel-name">{item.title}</div>
              <div className="subscribers">
                {`구독자 ${formatSubscribers(item.subscriberCount)}명 | `}
                {`동영상 ${formatVideos(item.videoCount)}개`}
              </div>
            </div>
            <div className="channel-description channel-description-multi">
              {item.chnlDesc}
            </div>
            <div className="likes">
              <svg
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                style={{ cursor: 'pointer' }}
                onClick={() => handleClick(item.chnlId)}
                width="30"
                height="30"
              >
                <g data-name="Layer 1" id="Layer_1">
                  <path
                    d="M16 29s13-8.35 13-14.15c0-5.03-3.4-8.66-7.5-8.66-2.86 0-4.91 2.11-5.5 3.56-0.59-1.45-2.64-3.56-5.5-3.56-4.1 0-7.5 3.63-7.5 8.66C3 20.65 16 29 16 29z"
                    fill={likesState[item.chnlId] === 'Y' ? '#ff0000' : 'none'} // likesYn에 따라 색상 변경
                    stroke={
                      likesState[item.chnlId] === 'Y' ? 'none' : '#101820'
                    }
                    strokeWidth="2"
                  />
                </g>
              </svg>
            </div>
            <div className="like-count">{formatVideos(item.likeCount)}</div>

            <div className="separator"></div>

            {item.videoId && (
              <div className="latest-video">
                <a
                  href={`https://www.youtube.com/watch?v=${item.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={item.videoThumbnail}
                    alt="최신 동영상 썸네일"
                    title={item.videoTitle}
                    className="latest-video-thumbnail"
                  />
                </a>
                <div className="latest-video-info">
                  게시일 :
                  {commonUtils.formatDate(item.videoPublishedAt || '', false)}
                </div>
              </div>
            )}
          </div>
        ))}
      </div> 
      */}

      <div className="mobile-ranking-container">
        {isLikedList && (
          <>
            {!isMobile ? (
              <div className="liked-ranking-header">
                <div className="liked-ranking-title">
                  내가 좋아요 한 유튜브 목록
                </div>
                <div className="liked-ranking-subtitle">
                  <div className="liked-description">
                    나만의 특별한 채널 컬렉션
                  </div>
                </div>
              </div>
            ) : (
              <div className="mobile-liked-ranking-header">
                <div className="mobile-liked-ranking-title">
                  <div className="mobile-liked-title-main">
                    내가 좋아요 한 유튜브 목록
                  </div>
                  <div className="mobile-liked-ranking-subtitle">
                    나만의 특별한 채널 컬렉션
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {isLikedList && (
          <>
            {data.map((item, index) => (
              <div className="mobile-ranking-item-compact" key={index}>
                <div className="mobile-main-content">
                  <div
                    className="mobile-logo-compact"
                    onClick={() => openYouTubeChannel(item.chnlId)}
                  >
                    <img src={item.thumbnailsDefault} alt={LOGO} />
                  </div>

                  <div className="mobile-channel-info-compact">
                    <div className="mobile-channel-name-compact">
                      {item.title || '채널명 없음'}
                    </div>
                    <div className="mobile-channel-stats">
                      {`구독자 ${formatSubscribers(item.subscriberCount)}명 | `}
                      {`동영상 ${formatVideos(item.videoCount)}개`}
                    </div>
                    <div className="mobile-channel-description-compact">
                      {item.description || '설명이 없습니다.'}
                    </div>
                  </div>

                  <div className="mobile-actions">
                    <div className="mobile-like-section-compact">
                      <svg
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mobile-heart-icon-compact"
                        width="20"
                        height="20"
                        fill="#ff4d4f"
                        onClick={() => handleClick(item.chnlId)}
                      >
                        <path
                          d="M16 29s-13-8.35-13-14.15C3 9.82 6.4 6.2 10.5 6.2c2.14 0 4.02 1.25 5.5 3.25C17.48 7.45 19.36 6.2 21.5 6.2c4.1 0 7.5 3.62 7.5 8.65C29 20.65 16 29 16 29z"
                          fill={
                            likesState[item.chnlId] === 'Y' ? '#ff0000' : 'none'
                          }
                          stroke={
                            likesState[item.chnlId] === 'Y' ? 'none' : '#101820'
                          }
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}

        {!isLikedList && (
          <>
            {!isMobile ? (
              <div className="ranking-header">
                <div className="ranking-title">
                  <div className="title-main">구독자별 국내 유튜브 순위</div>
                </div>
                <div className="ranking-update-info">
                  <div className="update-time">매일 오전 8시에 갱신됩니다</div>
                  <div className="update-frequency">24시간 주기로 업데이트</div>
                </div>
              </div>
            ) : (
              <div className="mobile-ranking-header">
                <div className="mobile-ranking-title">
                  <div className="mobile-title-main">
                    구독자별 국내 유튜브 순위
                  </div>
                  <div className="mobile-ranking-subtitle">
                    매일 오전 8시에 갱신됩니다
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {!isLikedList && (
          <>
            {data.map((item, index) => (
              <div className="mobile-ranking-item-compact" key={index}>
                <div className="mobile-main-content">
                  <div className="mobile-rank-compact">{item.chnlRank}</div>
                  <div
                    className="mobile-logo-compact"
                    onClick={() => openYouTubeChannel(item.chnlId)}
                  >
                    <img src={item.thumbnailsDefault} alt={LOGO} />
                  </div>
                  <div className="mobile-channel-info-compact">
                    <div
                      className="mobile-channel-name-compact"
                      title={item.description}
                    >
                      {item.title || '채널명'}
                    </div>
                    <div className="mobile-channel-stats">
                      {`구독자 ${formatSubscribers(item.subscriberCount)}명 | `}
                      {`동영상 ${formatVideos(item.videoCount)}개`}
                    </div>
                    <div
                      className="mobile-channel-description-compact"
                      title={item.description}
                    >
                      {item.description || '채널 설명이 없습니다.'}
                    </div>
                  </div>
                  <div className="mobile-actions">
                    <div className="mobile-like-section-compact">
                      <svg
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mobile-heart-icon-compact"
                        width="20"
                        height="20"
                        onClick={() => handleClick(item.chnlId)}
                      >
                        <path
                          d="M16 29s13-8.35 13-14.15c0-5.03-3.4-8.66-7.5-8.66-2.86 0-4.91 2.11-5.5 3.56-0.59-1.45-2.64-3.56-5.5-3.56-4.1 0-7.5 3.63-7.5 8.66C3 20.65 16 29 16 29z"
                          fill={
                            likesState[item.chnlId] === 'Y' ? '#ff0000' : 'none'
                          }
                          stroke={
                            likesState[item.chnlId] === 'Y' ? 'none' : '#101820'
                          }
                        />
                      </svg>
                      <span className="mobile-like-count-compact">
                        {item.likeCount || '0'}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mobile-latest-video-compact">
                  <a
                    href={`https://www.youtube.com/watch?v=${item.videoId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mobile-video-link-compact"
                  >
                    <img
                      src={item.videoThumbnail}
                      alt="최신 동영상"
                      title={item.videoTitle}
                      className="mobile-video-thumbnail-compact"
                    />

                    <div className="mobile-video-info-compact">
                      <div className="mobile-video-title-compact">
                        {item.videoTitle || '최신 동영상 제목 없음'}
                      </div>
                      <div className="mobile-video-date-compact">
                        {commonUtils.formatDate(
                          item.videoPublishedAt || '',
                          false,
                        )}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  )
}
